import { css } from '@emotion/react';
import { format } from 'date-fns';
import { theme } from 'styles/theme';

export const ConfirmedBox = ({ data }) => {
	return (
		<div
			css={css`
				display: flex;
				border-bottom: 1px solid #f1f1f4;
				background: #fafaff;
				flex-grow: 1;
				padding: 12px 20px;
				margin-bottom: 20px;
				position: fixed;
				top: 0;
				right: 0;
				left: 281px;
				justify-content: center;
				z-index: 2;
			`}
		>
			<div>
				<strong>✅ Booking byl odeslán.</strong>
			</div>

			<div
				css={css`
					margin-left: 12px;
					font-size: 13px;
					color: ${theme.color.text['300']};
				`}
			>
				Vyplnil <strong>{data?.confirmed_name}</strong> ({data?.confirmed_email},{' '}
				{data?.confirmed_phone}){', '}
				{format(new Date(data?.confirmed_at), 'dd. MM. YYY, HH:mm')}
			</div>
		</div>
	);
};
